import { useTranslation } from "react-i18next";
import { LegendBlock, LegendItem } from "src/features/dashboards/components/DashboardLegend";

import { BriefAssignmentState } from "@sol/sdk";

import { BriefStatusBadge, getStatusConfig } from "./BriefStatusBadge";

type Props = {
    counts: Record<BriefAssignmentState, number>;
};

export const ProgressionLegend = ({ counts }: Props) => {
    return (
        <LegendBlock>
            <ProgressionLegendItem status={undefined} counts={counts} />
            <ProgressionLegendItem status={BriefAssignmentState.ASSIGNED} counts={counts} />
            <ProgressionLegendItem status={BriefAssignmentState.RENDERED} counts={counts} />
            <ProgressionLegendItem status={BriefAssignmentState.CORRECTED} counts={counts} />
            <ProgressionLegendItem status={BriefAssignmentState.VALIDATED} counts={counts} />
        </LegendBlock>
    );
};

const ProgressionLegendItem = ({ status, counts }: { status?: BriefAssignmentState } & Props) => {
    const [t] = useTranslation(undefined, { keyPrefix: "features.dashboards.details.briefsProgress.status" });
    const config = getStatusConfig(status);
    return (
        <LegendItem
            picto={<BriefStatusBadge status={status} showTooltip={false} />}
            legend={`${t(config.label)} (${status ? counts[status] : 0})`}
        />
    );
};
